import React from "react";

const InnerHeader = ({ heading, desc }) => {
  return (
    <header className="inner-header">
      <img
        className="inner-header-img"
        src={"/inner-banner.jpg"}
        alt="inner-header-img"
      />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-12 text-center">
            <h1 className="sec-head white">{heading || "Title Here"}</h1>
            {desc && <p className="para white mb-0">{desc}</p>}
          </div>
        </div>
      </div>
    </header>
  );
};

export default InnerHeader;
